import {
  CustomAxiosType,
  GetMemberParams,
  GetNokResult,
  CustomAxiosSingleType,
  NokCrudType,
  DeleteMobility,
  PatchNokParams,
} from "../types/types";
import { client } from "./client";

const b6t = `NB6T`;

// 추가 알림 수신자 조회
export const getNok = async ({
  page,
  searchKey,
  area,
  sort,
  limit,
  groupId,
}: GetMemberParams) => {
  const response = await client.post<CustomAxiosType<GetNokResult>>(
    `/api/user` + b6t + `/nok/get`,
    {
      page,
      searchKey,
      area,
      sort,
      limit,
      groupId,
    }
  );
  return response.data.result;
};

// 추가 알림 수신자 삭제
export const deleteNok = async ({ seq }: DeleteMobility) => {
  const response = await client.post(`/api/user` + b6t + `/nok/delete`, {
    seq,
  });
  return response.data;
};

// 추가 알림 수신자 등록
export const postNok = async ({
  name,
  id,
  related_id,
  relation,
}: NokCrudType) => {
  const response = await client.post<CustomAxiosSingleType>(
    `/api/user` + b6t + `/nok`,
    {
      name,
      id,
      related_id,
      relation,
    }
  );
  return response.data;
};

// 보호자 수정
export const patchNok = async ({
  nok_name,
  nok_phone,
  relation,
  seq,
}: PatchNokParams) => {
  const response = await client.post<CustomAxiosSingleType>(
    `/api/user` + b6t + `/nok/patch`,
    {
      seq,
      nok_name,
      nok_phone,
      relation,
    }
  );
  return response.data;
};
